import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getTenantSubdomain } from '../constants/tenant';
import { tenantService } from '../services/api';
import { AuthLayout, AuthInput, AuthAlert, PrimaryButton, SecondaryButton } from '../components/layout/AuthLayout';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [companyName, setCompanyName] = useState<string | null>(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  // On a company's own subdomain, greet that company by name. Purely cosmetic: if the lookup fails
  // (root domain, unknown subdomain) the generic sign-in screen is shown.
  useEffect(() => {
    const subdomain = getTenantSubdomain();
    if (!subdomain) return;
    tenantService.getBranding(subdomain).then(b => setCompanyName(b.name)).catch(() => setCompanyName(null));
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      await login(username, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    }
  };

  return (
    <AuthLayout title="Welcome back 👋" subtitle={companyName ? `Sign in to ${companyName}` : 'Sign in to your MQBIT HRMS account'}>
      {error && <AuthAlert severity="error">{error}</AuthAlert>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <AuthInput
          label="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter your username"
          autoComplete="username"
          required
          autoFocus
        />
        <AuthInput
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          autoComplete="current-password"
          required
        />
        <div className="pt-2">
          <PrimaryButton type="submit">Sign In</PrimaryButton>
        </div>
        <SecondaryButton type="button" onClick={() => navigate('/forgot-password')}>
          Forgot Password?
        </SecondaryButton>
      </form>
    </AuthLayout>
  );
};

export default Login;
